<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" lg="12">
        <v-card v-if="eventDetails !== undefined && eventDetails !== null" style="padding: 0% 6% 0% 6%">
          <v-row style="margin-bottom: -30px">
            <v-col md="8" sm="12" style="text-align: left">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.eventName')"
                      v-model="eventName"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('eventName')"
                    ></v-text-field>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-menu v-model="menu_['eventDate']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$tc('dashboard.menu.eventDetails.eventDate')"
                          v-model="eventDate"
                          style="margin: 10px 0"
                          :append-icon="'fa-calendar'"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="300" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-date-picker
                            v-model="eventDate"
                            @change="saveDate"
                            :header-date-format="$datePicker.formatDateHeader"
                            :title-date-format="$datePicker.formatTitleDate"
                            :weekday-format="$datePicker.formatWeekday"
                            :month-format="$datePicker.formatMonth"
                          ></v-date-picker>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-menu v-model="menu_['eventEndDate']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$tc('dashboard.menu.eventDetails.eventEndDate')"
                          v-model="eventEndDate"
                          style="margin: 10px 0"
                          :append-icon="'fa-calendar'"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="300" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-date-picker
                            v-model="eventEndDate"
                            @change="saveEndDate"
                            :header-date-format="$datePicker.formatDateHeader"
                            :title-date-format="$datePicker.formatTitleDate"
                            :weekday-format="$datePicker.formatWeekday"
                            :month-format="$datePicker.formatMonth"
                          ></v-date-picker>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-select
                      :items="timezoneItems"
                      v-model="eventDetails.timezone"
                      dense
                      outlined
                      @change="change({ timezone: eventDetails.timezone.id }, 'timezone')"
                      :label="$tc('dashboard.menu.eventDetails.timezone')"
                      return-object
                      style="margin: 10px 0"
                      :no-data-text="$t('common.no_data')"
                    >
                      <template v-slot:item="{ item }">
                        <div v-html="item.text" />
                      </template>
                      <template v-slot:selection="{ item }">
                        <div v-html="item.text" />
                      </template>
                    </v-select>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line style="border-bottom: none;">
                <v-list-item-content>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.eventCreated')"
                      v-model="eventCreatedFormatted"
                      style="margin: 10px 0"
                      outlined
                      dense
                      disabled
                    ></v-text-field>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-select
                      v-model="displayFlag_"
                      :items="displayFlagItems"
                      item-text="text"
                      item-value="id"
                      dense
                      outlined
                      :label="$tc('dashboard.menu.eventDetails.displayFlag')"
                      @change="change({ displayFlag: displayFlag_.id }, 'displayFlag')"
                      return-object
                      style="margin: 10px 0;"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-select
                      v-model="displayRegistrationFlag_"
                      :items="registrationFlagItems"
                      item-text="text"
                      item-value="id"
                      dense
                      outlined
                      @change="change({ displayRegistrationFlag: displayRegistrationFlag_.id }, 'displayRegistrationFlag')"
                      :label="$tc('dashboard.menu.eventDetails.displayRegistrationFlag')"
                      return-object
                      style="margin: 10px 0"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col md="4" sm="12" class="image">
              <v-row>
                <v-col cols="12" md="12" lg="12">
                  <v-img height="100%" width="100%" :src="imageUrl" v-on:error="ImgError"></v-img>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <v-btn
                    style="width: 100%"
                    class="ma-2 button_"
                    outlined
                    @click="upload()"
                  >{{ $tc("dashboard.menu.eventDetails.change_your_image") }}</v-btn>
                  <input
                    style="display: none"
                    type="file"
                    id="uploadImage_"
                    name="uploadImage_"
                    accept="image/*"
                    @change="onImageChange($event)"
                    multiple
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-row>
            <v-col md="4" sm="12" class="column-bottom-detail">
              <v-list-item three-line>
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.address')"
                      v-model="address"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('address')"
                      :placeholder="$t('dashboard.menu.eventDetails.empty')"
                    ></v-text-field>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.city')"
                      v-model="city"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('city')"
                      :placeholder="$t('dashboard.menu.eventDetails.empty')"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col md="4" sm="12" class="column-bottom-detail">
              <v-list-item three-line>
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.eventState')"
                      v-model="eventState"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('eventState')"
                      :placeholder="$t('dashboard.menu.eventDetails.empty')"
                    ></v-text-field>
                  </v-list-item-title>
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.eventCountry')"
                      v-model="eventCountry"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('eventCountry')"
                      :placeholder="$t('dashboard.menu.eventDetails.empty')"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="4" sm="12" class="column-bottom-detail">
              <v-list-item three-line>
                <v-list-item-content class="pa-0 mb-auto">
                  <v-list-item-title
                    class="headline"
                  >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.eventDetails.zip')"
                      v-model="zip"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('zip')"
                      :placeholder="$t('dashboard.menu.eventDetails.empty')"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <SGSNotificationConfirm v-if="alertError" :notificationMessage="msg" 
    @cancel="alertError=false;" type="error" :reject="$t('common.form.cancel')"/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";
import axios from "axios";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import { YES_NO_OPTIONS } from '@/constants/selectOptions';


Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm
  },
  props: ["response"],
  data() {
    return {
      navigationBGColor: "#FFF",
      timezoneItems: [],
      menu_: [
        { eventName: false },
        { timezone: false },
        { displayFlag: false },
        { displayRegistrationFlag: false },
        { address: false },
        { city: false },
        { eventState: false },
        { eventCountry: false },
        { zip: false }
      ],
      eventName: null,
      eventDate: null,
      eventEndDate: null,
      timezone: null,
      displayFlag: null,
      displayFlag_: null,
      displayRegistrationFlag: null,
      displayRegistrationFlag_: null,
      address: null,
      city: null,
      eventState: null,
      eventCountry: null,
      zip: null,
      eventCreated: null,
      iconIndex: 0,
      imageUrl: null,
      failed_image: true,
      msg: '',
      alertError: false
    };
  },
  computed: {
    eventCreatedFormatted() {
      if (!this.eventCreated) return '';
      
      try {
        return this.$datePicker.capitalize(
          this.$options.filters.formatDateForHumans(this.eventCreated, false)
        );
      } catch (error) {
        return this.eventCreated;
      }
    },
    registrationFlagItems() { return YES_NO_OPTIONS(this); },
    displayFlagItems() { return YES_NO_OPTIONS(this); },
  },
  created: function() {
    this.navigationBGColor = process.env.VUE_APP_HEADER_COLOR;
  },
  asyncComputed: {
    eventCreated: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEventCreation/" +
          this.$route.params.id
      );
      this.eventDetails_();
      return response.message;
    },
    eventDetails: function() {
      let event = [];
      if(this.response !== null) {
        this.eventDetails_();
        event = this.response.message[0];
      }
      return event;
    }
  },
  methods: {
    async saveDate(date) {
      let data = {};

      data.eventDate = date;

      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          this.$route.params.id,
        data
      );

      this.eventDetails.eventDate = date;
      this.menu_.eventDate = false;
    },
    async saveEndDate(date) {
      let data = {};

      data.eventEndDate = date;

      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          this.$route.params.id,
        data
      );

      this.eventDetails.eventEndDate = date;
      this.menu_.eventEndDate = false;
    },
    async eventDetails_() {
      //var response = await this.api("get", "/api/v1/users/current/promoter/eventDetails/getEvent/" + this.$route.params.id);
      if(this.response !== null) {
        var response = await this.response;

        var getTimeZone = await this.api(
          "get",
          "/api/v1/promoter/eventDetails/getTimeZone/" +
            this.$route.params.id
        );

      this.eventName = response.message[0].eventName;
      this.eventDate = response.message[0].eventDate;
      this.eventEndDate = response.message[0].eventEndDate;
      this.timezone = getTimeZone.message;

      this.imageUrl = response.message[0].existFile
        ? process.env.VUE_APP_ROOT +
          "/laravel/public/" +
          response.message[0].image
        : this.failed_image
        ? process.env.VUE_APP_ROOT + "/" + response.message[0].image
        : require("@/assets/images/orgPlaceholder.jpg.png");

      this.address = response.message[0].address;
      this.eventState = response.message[0].eventState;
      this.zip = response.message[0].zip;
      this.city = response.message[0].city;
      this.eventCountry = response.message[0].eventCountry;

      this.displayFlag =
        response.message[0].displayFlag == 1
          ? this.$t("dashboard.menu.eventDetails.yes")
          : this.$t("dashboard.menu.eventDetails.no");

      this.displayFlag_ = response.message[0].displayFlag == 1 || response.message[0].displayFlag == 'Yes' ? 1 : 0;

      this.displayRegistrationFlag =
        response.message[0].displayRegistrationFlag == 1
          ? this.$t("dashboard.menu.eventDetails.yes")
          : this.$t("dashboard.menu.eventDetails.no");

      this.displayRegistrationFlag_ =
        response.message[0].displayRegistrationFlag == 1 || response.message[0].displayRegistrationFlag == 'Yes' ? 1 : 0;

      response.message[0].timezone = getTimeZone.message;
      response.message[0].displayRegistrationFlag = this.displayRegistrationFlag;
      response.message[0].displayFlag = this.displayFlag;

      this.eventDetails = response.message[0];

      const getTimeZones = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getTimeZones"
      );

      let arrayItems = [];

      Object.entries(getTimeZones.message).forEach(([key, value]) => {
        arrayItems.push({
          id: key,
          text: value
        });
      });

      this.timezoneItems = arrayItems;
      }
    },
    async change(data, parameter) {
      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          this.$route.params.id,
        data
      );

      if (parameter == "timezone") {
        var timezone = this.timezoneItems.find(
          element => element.id == data.timezone
        );
        this.eventDetails.timezone = timezone.text;
      } else if (parameter == "displayRegistrationFlag") {
        this.displayRegistrationFlag =
          data.displayRegistrationFlag == 1
            ? this.$t("dashboard.menu.eventDetails.yes")
            : this.$t("dashboard.menu.eventDetails.no");
        const select = this.registrationFlagItems .filter((item) => item.id === data.displayRegistrationFlag);
        this.displayRegistrationFlag_ = select.length > 0 ? select[0] : null;
      } else {
        this.displayFlag =
          data.displayFlag == 1
            ? this.$t("dashboard.menu.eventDetails.yes")
            : this.$t("dashboard.menu.eventDetails.no");
        const select = this.displayFlagItems.filter((item) => item.id === data.displayFlag);
        this.displayFlag_ = select.length > 0 ? select[0] : null;
      }
    },
    upload() {
      document.getElementById("uploadImage_").click();
    },
    async onImageChange(e) {
      this.uploadImage_ = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.fileName = files[0].name;
      this.uploadImage();
    },
    async createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    async uploadImage() {
      const data = new FormData();
      data.append("image", this.uploadImage_);
      data.append("fileName", this.fileName);

      let axiosConfig = {
        headers: { "content-type": "multipart/form-data" }
      };

      const response = await axios
        .post(
          `${this.root}/laravel/public/api/v1/promoter/eventDetails/updateEventImage/${this.$route.params.id}`,
          data,
          axiosConfig
        )
        .catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );

      if (response.data.success == 1) {
        this.imageUrl =
          process.env.VUE_APP_ROOT + "/laravel/public/" + response.data.message;
      }else{
          this.msg = this.$t('dashboard.menu.raceDetails.alertFile');
          this.alertError = true;
      }
    },
    close(id) {
      this.eventName = this.eventDetails.eventName;
      this.timezone = this.eventDetails.timezone;
      this.displayFlag = this.eventDetails.displayFlag;
      this.displayRegistrationFlag = this.eventDetails.displayRegistrationFlag;
      this.address = this.eventDetails.address;
      this.city = this.eventDetails.city;
      this.eventState = this.eventDetails.eventState;
      this.eventCountry = this.eventDetails.eventCountry;
      this.zip = this.eventDetails.zip;

      this.menu_[id] = false;
    },
    async sendMessage(input) {
      let data = {};

      if (input == "address") {
        data.address = this.address;
      } else if (input == "city") {
        data.city = this.city;
      } else if (input == "eventState") {
        data.eventState = this.eventState;
      } else if (input == "eventCountry") {
        data.eventCountry = this.eventCountry;
      } else if (input == "zip") {
        data.zip = this.zip;
      } else if (input == "eventName") {
        data.eventName = this.eventName;
      }

      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          this.$route.params.id,
        data
      );

      this.eventDetails.address =
        this.address != "" && this.address != null
          ? this.address
          : this.$t("dashboard.menu.eventDetails.empty");

      this.eventDetails.city =
        this.city != "" && this.city != null
          ? this.city
          : this.$t("dashboard.menu.eventDetails.empty");

      this.eventDetails.eventState =
        this.eventState != "" && this.eventState != null
          ? this.eventState
          : this.$t("dashboard.menu.eventDetails.empty");

      this.eventDetails.eventCountry =
        this.eventCountry != "" && this.eventCountry != null
          ? this.eventCountry
          : this.$t("dashboard.menu.eventDetails.empty");

      this.eventDetails.zip =
        this.zip != "" && this.zip != null
          ? this.zip
          : this.$t("dashboard.menu.eventDetails.empty");

      this.eventDetails.eventName = this.eventName;

      this.menu_[input] = false;
    },
    async ImgError() {
      this.failed_image = false;
      this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
    }
  }
};
</script>

<style>
.v-application a {
  color: rgba(255, 255, 255, 0.7);
}
.v-application .headline {
  /*font-size: 14px !important;*/
  color: #aaa !important;
}

.theme--light.v-list-item .v-list-item__subtitle,
.theme--light.v-list-item .v-list-item__action-text {
  color: #555555;
  font-weight: 700;
  font-size: 16px;
  padding-left: 2%;
  padding-bottom: 1%;
}
.column-bottom-detail {
  text-align: left; 
  padding: 0 12px 35px;
}
.column-bottom-detail .v-list-item {
  border-bottom: none;
}
.v-menu__content {
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}
.text-input-date {
  margin: 0 auto;
  -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
@media (max-width: 1024px) {
  .theme--light.v-list-item .v-list-item__subtitle,
  .theme--light.v-list-item .v-list-item__action-text {
    font-size: 11.5px;
    padding-left: 2%;
    padding-bottom: 2%;
  }

  .image {
    padding: 8%;
  }

  .button_ {
    font-size: 10.5px !important;
  }
}
</style>
